import _ from "lodash";
import FixedContributionService from "../provider/FixedContribution/FixedContributionService";
import { SUCCESS, ERROR } from "../common/Util";
import {
	CHANGE_APP_PROPS,
	CHANGE_FIXED_CONTRIBUTION_PROPS
} from "./ActionConstants";

export function actionGetFixedContributionsList(searchText, offset, limit) {
	return dispatch => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: true
			}
		});
		asyncGetFixedContributionList(searchText, offset, limit).then(response => {
			dispatch({
				type: CHANGE_FIXED_CONTRIBUTION_PROPS,
				props: {
					fixedContributionsList: response,
					total: !_.isEmpty(response) ? response[0].cantidad : 0
				}
			});
			dispatch({
				type: CHANGE_APP_PROPS,
				props: {
					loading: false
				}
			});
		});
	};
}

async function asyncGetFixedContributionList(searchText, offset, limit) {
	let response = await FixedContributionService.getFixedContributionList(
		searchText,
		offset,
		limit
	);
	return response;
}

export function actionCreateFixedContribution(values, callback) {
	return dispatch => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: true
			}
		});
		values = formatObjectToJSON(values);
		asyncCreateFixedContribution(values)
			.then(() => callback(SUCCESS))
			.catch(() => callback(ERROR))
			.then(() =>
				dispatch({
					type: CHANGE_APP_PROPS,
					props: {
						loading: false
					}
				})
			);
	};
}

async function asyncCreateFixedContribution(values) {
	let response = await FixedContributionService.setFixedContribution(values);
	return response;
}

function formatObjectToJSON(values) {
	if (values.fixedContribution_type) {
		values.fixedContribution_type = { id: values.fixedContribution_type };
	}
	return values;
}

export function actionUpdateFixedContribution(
	fixedContributionId,
	values,
	callback
) {
	return (dispatch, store) => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: { loading: true }
		});
		values = formatObjectToJSON(values);
		asyncUpdateFixedContribution(fixedContributionId, values)
			.then(response => {
				let fixedContributionList = store().fixedContribution
					.fixedContributionsList;
				const fixedContributionIndex = fixedContributionList.findIndex(e => {
					return e.id === response.id;
				});
				fixedContributionList[fixedContributionIndex] = response;
				dispatch({
					type: CHANGE_FIXED_CONTRIBUTION_PROPS,
					props: {
						fixedContribution: response,
						fixedContributionsList: fixedContributionList
					}
				});
				callback(SUCCESS);
			})
			.catch(() => callback(ERROR))
			.then(() =>
				dispatch({
					type: CHANGE_APP_PROPS,
					props: { loading: false }
				})
			);
	};
}

async function asyncUpdateFixedContribution(fixedContributionId, values) {
	let response = await FixedContributionService.updateFixedContribution(
		fixedContributionId,
		values
	);
	return response;
}

export function actionDeleteFixedContribution(fixedContributionId, callback) {
	return dispatch => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: true
			}
		});
		asyncDeleteFixedContribution(fixedContributionId)
			.then(() => callback(SUCCESS))
			.catch(() => callback(ERROR))
			.then(() =>
				dispatch({
					type: CHANGE_APP_PROPS,
					props: {
						loading: false
					}
				})
			);
	};
}

async function asyncDeleteFixedContribution(fixedContributionId) {
	let response = await FixedContributionService.deleteFixedContribution(
		fixedContributionId
	);
	return response;
}

export function actionChangeFixedContributionProps(props) {
	return dispatch => {
		dispatch({
			type: CHANGE_FIXED_CONTRIBUTION_PROPS,
			props: props
		});
	};
}



// WEBPACK FOOTER //
// ./src/actions/FixedContributionActions.js